export default __webpack_public_path__ + "static/media/iPhone11.ef539d8e.png";